import useSWR from "swr";
import getBuyerAPIDomain from "../getBuyerAPIDomain";
import getRangeFacetCounts from "./getRangeFacetCounts";
import { MappedRangeFacetItem, FacetType } from "./filters.type";
import { enabledCategories } from "./filtersConfig";
import { useSelector } from "react-redux";
import { StoreType } from "../StoreType";
import { GET_STATE } from "../redux/slices/appSlice";
import { useAuth } from "@bca-auth0/bca-auth0-provider";

export function useRangeFacet(
  allQueryStrings: any,
  currentFacet: FacetType | null
) {
  const {
    app: { isToUseAuthZero },
  }: StoreType = useSelector(GET_STATE);
  const { accessToken } = useAuth(!isToUseAuthZero);

  const buyerAPIDomain = getBuyerAPIDomain(isToUseAuthZero);
  const getRangeFacetCountUrl = buyerAPIDomain
    ? new URL(
        `${buyerAPIDomain.href}/search/rangeFacet?currentFacet=${currentFacet}`,
        buyerAPIDomain
      )
    : null;

  const appliedFilters = allQueryStrings["bq"];
  if (getRangeFacetCountUrl && appliedFilters?.length > 0) {
    const valToAppend = appliedFilters
      .split("|")
      .filter((item) => !item.includes(`${currentFacet}:`))
      .join("|");
    if (valToAppend?.length > 0) {
      getRangeFacetCountUrl.searchParams.append("bq", valToAppend as string);
    }
  }

  const freeSearchText = allQueryStrings["q"];
  if (freeSearchText) {
    getRangeFacetCountUrl.searchParams.append("q", freeSearchText as string);
  }

  const missingMileage = allQueryStrings["missingMileage"];
  if (missingMileage) {
    getRangeFacetCountUrl.searchParams.append(
      "missingMileage",
      missingMileage as string
    );
  }

  const awaitingAppraisal = allQueryStrings["awaitingAppraisal"];
  if (awaitingAppraisal) {
    getRangeFacetCountUrl.searchParams.append(
      "awaitingAppraisal",
      awaitingAppraisal as string
    );
  }

  const isRangeFilter = enabledCategories.range.includes(currentFacet);
  const {
    data: facetCounts,
    error: facetCountsError,
    mutate: mutateCurrentFacet,
  } = useSWR<MappedRangeFacetItem[]>(
    currentFacet && isRangeFilter && (accessToken || !isToUseAuthZero)
      ? [getRangeFacetCountUrl.href, currentFacet, accessToken, isToUseAuthZero]
      : null,
    getRangeFacetCounts,
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    }
  );

  return { facetCounts, facetCountsError, mutateCurrentFacet };
}
